// MAIN JS

  $.fn.exists = function(callback) {
    var args = [].slice.call(arguments, 1);

    if (this.length) {
      callback.call(this, args);
    }

    return this;
  };

  (function($,sr){

  var debounce = function (func, threshold, execAsap) {
      var timeout;

      return function debounced () {
          var obj = this, args = arguments;
          function delayed () {
              if (!execAsap)
                  func.apply(obj, args);
              timeout = null;
          };

          if (timeout)
              clearTimeout(timeout);
          else if (execAsap)
              func.apply(obj, args);

          timeout = setTimeout(delayed, threshold || 100);
      };
  }
  // smartresize 
  jQuery.fn[sr] = function(fn){  return fn ? this.bind('resize', debounce(fn)) : this.trigger(sr); };

  })(jQuery,'smartresize');


jQuery(document).ready(function ($){

  FastClick.attach(document.body);

  

  var menuToggle = $('.menu-toggle'),
      menuContainer = $('.menu-container');

    menuToggle.on('click', function (e) {
        e.preventDefault();
        desplegarMenu();
    });
  function desplegarMenu() {
          $('body').toggleClass('menu-opened');
  };

  $('.p-video-embed').one('click', function(e) {
    e.preventDefault();
    var embed = $(this).data('embed');
    $(this).html(embed).removeClass('ready-to-play').css('background-image','none');
  });

  $('.p-button-film').one('click', function(e) {
    e.preventDefault();
    $('.home-slider').slick('slickPause');
    var followVideo = $(this).parents('.home-slider-item').find('.p-video-embed-home'),
        embed = followVideo.data('embed');
    followVideo.html(embed).removeClass('ready-to-play hidden');
    // console.log(followVideo);
    $(this).parents('.home-slider-item').find('img').remove();
    $(this).parent().remove();
  });


  $(".home-slider").on("beforeChange", function(event, slick) {
      
      var currentSlide, slideType, player, command;
      
      currentSlide = $(slick.$slider).find(".slick-current");
      slideType = currentSlide.attr("class").split(" ")[1];
      player = currentSlide.find("iframe").get(0);
      
      if (slideType == "home-slider-item-vimeo") {
        command = {
          "method": "pause",
          "value": "true"
        };
      } else {
        command = {
          "event": "command",
          "func": "pauseVideo"
        };
      }
      
      
      if (player != undefined) {
        //post our command to the iframe.
        player.contentWindow.postMessage(JSON.stringify(command), "*");
      }    
  });
  
  $('.p-open-request').click(function(e) {
    e.preventDefault();
    $('body').addClass('p-request-active');
  });


  $('.p-modal').click(function(e) {
    e.preventDefault();
    $('body').removeClass('p-request-active');
  });

  $('.p-request').click(function(event){
      event.stopPropagation();
  });


  var divs = $('.p-fade');

  $.each(divs, function(i, item) {

      $(item).one('inview', function(event, isInView, visiblePartX, visiblePartY) {
        if (isInView) {
          // setTimeout(function() {
            $(item).addClass('p-visible');
          // }, 70 * i);
        }
      });

  });

  var divsDetail = $('.p-detail-fade');

  $.each(divsDetail, function(i, item) {

      $(item).one('inview', function(event, isInView, visiblePartX, visiblePartY) {
        if (isInView) {
          // setTimeout(function() {
            $(item).addClass('p-detail-visible');
          // }, 70 * i);
        }
      });

    });

    $('.images-slider').slick({
        autoplay: false,
        dots: false,
        adaptiveHeight: true,
        asNavFor: '.images-thumb-slider',
        arrows: true,
        infinite: false,
        lazyLoad: 'progressive',
        pauseOnHover: true,
        accessibility: true,
        responsive: [
            {
              breakpoint: 320,
              settings: {
                adaptiveHeight: false,
                }
            }
        ]
    });
    
    function altoFlexible() {
      
        var globalHeight = $(window).height(),
            hederHeight = $('.peregrin-header').outerHeight(),
            entryHeaderHeight = $('.entry-header').outerHeight(),
            thumbsHeight = $('.images-series-thumb-wrapper').outerHeight(),
            visorSlider = $('.images-series-wrapper'),
            imagesSeriesItem = $('.images-series-item'),
            imagenCurrent = $('.images-series-wrapper .slick-current img').outerHeight(),

            resultHeight = globalHeight - (hederHeight + entryHeaderHeight + thumbsHeight) - 32;
        
        if (globalHeight < 600) {
          resultHeight = globalHeight - ( entryHeaderHeight + thumbsHeight) - 32;
        }
      if ($(window).width() > 767) {
        imagesSeriesItem.height(resultHeight);
        $('.images-slider .slick-list').height(resultHeight);

      } else {
        imagesSeriesItem.height(imagenCurrent);
        $('.images-slider .slick-list').height(imagenCurrent);
        // console.log(imagenCurrent);
        
      }
    }

  setTimeout(function() {
      altoFlexible();
    }, 600);
  
  $('.images-slider .images-series-item').first().imagesLoaded( { background: true }, function() {
    // console.log('1st image loaded');
    altoFlexible();
  });



    if ($(window).width() < 768) {

      $('.images-slider').on('afterChange', function(event, slick, currentSlide, nextSlide){
           setTimeout(function() {
              altoFlexible();
            }, 200);
      });



    }

    $(window).smartresize(function() {
       setTimeout(function() {
          altoFlexible();
        }, 100);

      
        var currentSelected = $('.p-filters-list li.active'),
        filterActive = currentSelected.position(),
        filterList = $('.p-filters-list').width();
        
        setTimeout(function() {
          $('.p-filters-list').scrollLeft(filterActive.left - (filterList / 2) + (currentSelected.width() / 2) + 17);
        }, 300);
    });


    $('.images-thumb-slider').slick({
        autoplay: false,
        slidesToShow: 1,
        dots: false,
        adaptiveHeight: true,
        asNavFor: '.images-slider',
        focusOnSelect: true,
        centerMode: true,
        variableWidth: true,
        arrows:false,
        infinite: false,
        lazyLoad: 'progressive',
        responsive: [
            {
              breakpoint: 320,
              settings: {
                adaptiveHeight: false,
                }
            }
        ]
    });

    $('.images-makingof-slider').slick({
        autoplay: false,
        slidesToShow: 2,
        slidesToScroll: 2,
        dots: true,
        adaptiveHeight: false,
        arrows:true,
        infinite: false,
        lazyLoad: 'progressive',
        accessibility: false,
        responsive: [
            {
              breakpoint: 320,
              settings: {
                // adaptiveHeight: false,
                }
            }
        ]
    });

    $('.home-slider').slick({
        autoplay: true,
        dots: true,
        adaptiveHeight: true,
        arrows: false,
        // fade: true,
        // cssEase: 'linear',
        pauseOnHover: false,
        speed: 380,
        lazyLoad: 'progressive',
        autoplaySpeed: 6000
    });


    $('.p-bio-lang').slick({
        autoplay: false,
        dots: false,
        adaptiveHeight: true,
        draggable: false,
        arrows: false
    });

     // Filter Ajax Load More
     var alm_is_animating = false;
     if (typeof currentType === 'undefined') {
      $('#alm-filter-nav li').eq(0).addClass('active'); // Set the initial button active state
     } else {
      $('#alm-filter-nav li a[data-taxonomy-terms="' + currentType + '"]').parent().addClass('active');
     }
     
     
     // Nav btn click event
     $('#alm-filter-nav li a').on('click', function(e){    
        e.preventDefault();  
        var el = $(this); // Our selected element     
        
        if(!el.hasClass('active') && !alm_is_animating){ // Check for active and !alm_is_animating  
           alm_is_animating = true;   
           el.parent().addClass('active').siblings('li').removeClass('active'); // Add active state       
        
           var data = el.data(), // Get data values from selected menu item
               transition = 'fade', // 'slide' | 'fade' | null
               speed = '180'; //in milliseconds
               
           $.fn.almFilter(transition, speed, data); // reset Ajax Load More (transition, speed, data)     
        }      
     });
     
     $.fn.almFilterComplete = function(){      
        alm_is_animating = false; // clear alm_isanimating flag
     };

     $('a.gallery').featherlightGallery({
        openSpeed: 300
    });

    $('.single-photos ').exists(function() {
      setTimeout(function() {
        $('#page').addClass('p-header-out');
      }, 1000);

      var barraTemporal = $('#page').find('.entry-header');

      barraTemporal.on('mouseover', function() {
        $('#page').removeClass('p-header-out');
      });

      $('.entry-content').on('mouseover', function() {
        $('#page').addClass('p-header-out');
      });
    });


    $('body.single').exists(function() {
      if ($('.images-series-thumb-item').length < 2) {
        $('.images-series-thumb-item').hide();
      }
    });
    
    var currentSelected = $('.p-filters-list li.active'),
    filterActive = currentSelected.position(),
    filterList = $('.p-filters-list').width();
    
    $('.p-filters-list').scrollLeft(filterActive.left - (filterList / 2) + (currentSelected.width() / 2) + 17);

      console.log(filterList);
});